var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    d: "m38.256,0l-26.512,0c-0.963,0 -1.744,0.781 -1.744,1.744l0,7.259l30,0l0,-7.259c0,-0.963 -0.781,-1.744 -1.744,-1.744z",
    fill: "#2d92d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    d: "m10,27.054l0,7.202c0,0.963 0.781,1.744 1.743,1.744l26.513,0c0.963,0 1.744,-0.781 1.744,-1.744l0,-7.202l-30,0z",
    fill: "#2150a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    d: "m10,9.003l30,0l0,9.002l-30,0l0,-9.002z",
    fill: "#2d83d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    d: "m10,18.005l30,0l0,9.05l-30,0l0,-9.05z",
    fill: "#2e70c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    d: "m18.319,28l-16.638,0c-0.928,0 -1.681,-0.753 -1.681,-1.681l0,-16.638c0,-0.928 0.753,-1.681 1.681,-1.681l16.638,0c0.928,0 1.681,0.753 1.681,1.681l0,16.638c0,0.928 -0.753,1.681 -1.681,1.681z",
    fill: "#00488d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    d: "m14.403,13l-1.546,7.264l-1.713,-7.264l-2.187,0l-1.767,7.489l-1.593,-7.489l-1.956,0l2.344,10l2.352,0l1.713,-7.689l1.714,7.689l2.251,0l2.344,-10l-1.956,0z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.e173d9669de9e0bb3f02b2cb8e930b5a.svg";
export { ForwardRef as ReactComponent };